import React from 'react';
import { ContextMenu, MenuItem, SubMenu } from 'react-contextmenu';
import s from './facets.module.css';

// https://github.com/vkbansal/react-contextmenu
// https://github.com/vkbansal/react-contextmenu/blob/master/docs/api.md
// https://vkbansal.github.io/react-contextmenu/#/
// submenu example https://github.com/vkbansal/react-contextmenu/blob/master/examples/SubMenus.js
// https://github.com/vkbansal/react-contextmenu/blob/master/examples/react-contextmenu.css

// styles are some in ./facets.module.css and some in globalStyles.css
const FacetsContextMenu = (props) => {
  const { menuId } = props;

  return (
    <div>
      <ContextMenu id={menuId} className={s.menuContextContainer}>
        <MenuItem>
          Option 1
      </MenuItem>
        <MenuItem>
          Option 2
        <span role='img'> 🤩</span>
        </MenuItem>
        <MenuItem>
          Option 3
      </MenuItem>
        <SubMenu title='some Submenu &#10148;' className={s.menuContextContainer}>
          <MenuItem>
            Option 1
        </MenuItem>
          <MenuItem>
            Option 2
        </MenuItem>
          <MenuItem>
            Option 3
        </MenuItem>
        </SubMenu>
      </ContextMenu>
    </div>
  );
};

export default FacetsContextMenu;

// menuContextContainer
